import React, { forwardRef } from 'react';
import { Colors, textColorClasses } from '@/lib/colorUtils';
import { cn, fontBase } from '@/lib/styleUtils';
import {
  TextProps,
  TextTag,
  TextAlign,
  TextSizes,
  TextWeights,
  TextLineHeights,
} from './Text.types';

const TextInner = (
  {
    children,
    size = '14',
    color = Colors.colorFont,
    weight = 'regular',
    lineHeight = '1',
    tag,
    textAlign = TextAlign.left,
    truncate = false,
    className,
    ...rest
  }: TextProps<any>,
  ref: React.Ref<HTMLElement>
) => {
  const classes = cn(
    fontBase,
    'tw:m-0 tw:box-border',
    TextSizes[size],
    TextWeights[weight],
    TextLineHeights[lineHeight],
    textAlign,
    textColorClasses[color],
    truncate && 'tw:truncate',
    className
  );

  const Component = (tag ?? TextTag.div) as React.ElementType;

  return (
    <Component ref={ref} className={classes} {...rest}>
      {children}
    </Component>
  );
};

export const Text = forwardRef(TextInner as any) as unknown as <
  TTag extends React.ElementType = 'div',
>(
  props: TextProps<TTag> & { ref?: React.Ref<HTMLElement> }
) => React.ReactElement | null;
